/**
 * Helper to get the keys of an object in a typed way.
 * All it does is adding generic types around Object.keys().
 */
const getObjectKeys = Object.keys as <T extends Record<string, unknown>>(
  obj: T
) => Array<keyof T>;

export { getObjectKeys };
